import React from 'react'
const About = () => {
   return (
      <section id="about" className="about">
         <div className="about__card">
            <h3 className="about__cardHeader">About Me</h3><br></br>
            <div className="about__content">
               <div className="about__cardContent">
                  <p>Hey🙋‍♂, Parth Jain here, I am a second year student at Indian Institute of Technology 
                  Ropar (IIT-RPR)🏫and coordinator at Coding Club.</p><br></br><p> I love to explore new things and implement them. 
                  I am currently focusing on
                  <a href="https://codeforces.com/profile/parthljain2002">👨‍💻</a>competitive 
                  programming and exploring web development. Always excited to build something new 
                  and collaborate on exciting projects. Also interested in robotics and finance.</p>
                  <p>I also write blogs on future tech and finance: <a href="https://pj02.medium.com/">@PJ02</a></p>
               </div>
               
            </div>
         </div>
      </section>
   )
}

export default About
